import { render, staticRenderFns } from "./Prometheus.vue?vue&type=template&id=f42e958c&scoped=true"
import script from "./Prometheus.vue?vue&type=script&lang=js"
export * from "./Prometheus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42e958c",
  null
  
)

export default component.exports